<template>
  <div class="signin">
    <el-form v-if="!dialogVisible" label-width="0" class="login-form" style="min-height: 350px!important;" >
      <p class="info-main">
        {{ $t('default.title') }}
      </p><br/>
      <p class="info-p">Real-world Registry Study of Red Light Treatment on Myopia Control: a Focus on Non-responders to Conventional Treatments
      </p><br/>
      <el-button @click="handleOpen" style="margin-bottom: 20px;"  class="login-button" type="primary">
        {{ $t('default.participant_login') }}
      </el-button>
      <el-button @click="open" class="login-button2" type="primary">
        {{ $t('default.researcher_login') }}
      </el-button>
    </el-form>
    <el-form v-if="dialogVisible" label-width="0" class="login-form" style="" :model="form">
      <p class="info-main">
        {{ $t('default.title') }}
      </p><br/>
      <p class="info-p">Real-world Registry Study of Red Light Treatment on Myopia Control: a Focus on Non-responders to Conventional Treatments
      </p><br/>
      <el-form-item >
        <el-input v-model="form.studyId" placeholder="StudyID"></el-input>
      </el-form-item>
      <el-form-item >
        <el-input v-model="form.certificate" :placeholder=" $t('default.password')"></el-input>
      </el-form-item>
      <el-button style="margin-bottom: 20px;" @click="signIn" class="login-button" type="primary">
        {{ $t('default.participant_login') }}
      </el-button>
      <el-button @click="open" class="login-button2" type="primary">
        {{ $t('default.researcher_login') }}
      </el-button>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      resultUrl: '',
      locale: 'en',
      time: 0,
      max_time: 600,
      langMap: {
        en: 'English',
        zh: '简体中文'
      },
      form: {
        certificate: '',
        studyId: ''
      }
    }
  },
  computed: { ...mapState({
      fundus: state => state.fundus.fundus
    }),
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false
    },
    handleOpen(done) {
      this.dialogVisible = true
    },
    open () {
      const language = navigator.language || navigator.userLanguage;
      if (language !== 'zh-CN') {
        return window.open('https://en-edc.visiontechmed.com/signin')
      }
      window.open('https://edc.visiontechmed.com/')
    },
    async signIn () {
      let result = {}
      try {
        result = await axios.post('/api/signin', this.form)
      } catch (e) {
        // 在这里轮询
        const err = e.response
        console.log(err.data)
        this.$notify.error({ title: 'Error', message: `[${err.data.code}] ${err.data.msg}`, duration: 5000 })
      }
      console.log(result)
      if (result.data.code === 0) {
        this.dialogVisible = false
        const { projectId, birthday, ethnicity, sex, _id, name } = result.data.data
        this.$router.push({
          path: `/workspace`,
          query: {
            projectId,
            subjectId: _id,
            studyId: this.form.studyId,
            birthday,
            ethnicity,
            name,
            sex
          }
        })
      }
    }
  }
}
</script>
<style lang="less">
@media screen and (max-width: 500px) {
  .signin {
    align-items: start!important;
  }
}
.signin {
  background: url('../../assets/background.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  .login-form {
    text-align: left;
    min-height: 450px;
    font-family: Avenir Next;
    width: 384px;
    box-shadow: 0 16px 28px 0 rgba(0, 0, 0, .22), 0 25px 55px 0 rgba(0, 0, 0, .21);
    border: 1px solid #dfdfdf;
    background: #fff;
    padding: 50px 24px 0;
    .login-button {
      color: #fff!important;
      background: #218DBB;
      margin: 0 0;
      background-position: 100% 0;
      background-size: 200% 100%;
      font-size: 20px!important;
      transition-duration: .4s;
      border: 0!important;
      width: 100%;
    }
    .login-button2 {
      color: #333;
      margin: 0 0;
      background-position: 100% 0;
      background-size: 200% 100%;
      font-size: 20px!important;
      transition-duration: .4s;
      border: 0!important;
      width: 100%;
      background: #D8D9E5;
    }
    .info-main {
      font-size: 20px;
      font-weight: 800;
    }
  }
}
</style>